import React from "react";
import styled from "styled-components";
import { FeatureRequest } from "interfaces/feature-request";
import Timeline from "./components/Timeline";
import { Paragraph, TabHeader } from "../shared/generic";
import { useTranslate } from "hooks/common/useTranslate/useTranslate";
import { useHierarchicalNavigation } from "hooks/common/useHierarchicalNavigation/useHierarchicalNavigation";

const DependencyTitle = styled.h6`
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 500;
`;

const DependencyButton = styled.button`
    display: block;
    background: none;
    color: #d5121e;
    border: none;
    padding: 0;
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }

    &:focus {
        outline: none;
        text-decoration: underline;
    }
`;

const DescriptionTab: React.FC<{
    featureRequest: FeatureRequest;
}> = ({ featureRequest }) => {
    const translate = useTranslate();
    const { move } = useHierarchicalNavigation("featureRequestId", "previousFeatureRequestIds");

    return (
        <>
            <TabHeader>
                {translate("featureRequests.featureRequestDescription.shortDescription")}
            </TabHeader>
            <Paragraph>{featureRequest.description}</Paragraph>
            {featureRequest.dependencies.length ? (
                <Paragraph>
                    <DependencyTitle>Aiheeseen liittyvät kehitysehdotukset</DependencyTitle>
                    {featureRequest.dependencies.map((dep) => (
                        <DependencyButton onClick={() => move(dep.id)} key={dep.id}>
                            • {dep.name}
                        </DependencyButton>
                    ))}
                </Paragraph>
            ) : (
                ""
            )}
            <Timeline featureRequest={featureRequest} />
        </>
    );
};

export default DescriptionTab;
